import React, { useMemo, useState } from "react";
import countryList from "react-select-country-list";
import {
  Layout,
  Input,
  Button,
  Card,
  Typography,
  Form,
  message,
  Select,
  Steps,
  InputNumber,
  Upload,
} from "antd";
import { RightOutlined } from "@ant-design/icons";
import { utilities } from "../../utilities/utlities";
import { profileconfig } from "../../configurations/profileconfig";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
export default function FourthStep(props) {
  const { Content } = Layout;
  const { Title, Text, Link } = Typography;
  const { Step } = Steps;
  const { Option } = Select;
  const [userData, setUser] = React.useState()
  const loggedUser = utilities.loggedUser()
  const [errorMessage,setError] = useState(false)
  var options = useMemo(() => countryList().getLabels(), []);
  React.useEffect(() => {
    setUser(props.userdata)

  }, [props.userdata, userData])
  const NextStep = () => {
    if(userData?.firstName_billing == undefined){
      setError(true)
      return
    }
    if(userData?.lastName_billing == undefined){
      setError(true)
      return
    }
    if(userData?.email_billing == undefined){
      setError(true)
      return
    }
    if(userData?.jobTitle_billing == undefined){
      setError(true)
      return
    }
    if(userData?.department_billing == undefined){
      setError(true)
      return
    }
    setError(false)
    props.CompleteRegistration(4)
  }
  return (
    <Card
      style={{ width: 300 }}
      bordered={true}
      className="login-container"
    >
      <Form
        autoComplete="off"
        className="loginForm"
        layout="vertical"
        name="nest-messages"
        onFinish={() => { }}
        validateMessages={() => { }}
      >
        {

          profileconfig[loggedUser?.type]['4'].fields.map(item => {
            if (item?.type == 'Label') {
              return <Form.Item>
                <Title level={5}>
                  {item.label}
                </Title>
              </Form.Item>
            }
            else if (item?.type == "Text" || item?.type == "Number" || item?.type == "email") {
              return <Form.Item
                className={item.itemclass}
                rules={[
                  {
                    required: true,
                    message: "Please input your First Name",
                  },
                ]}
              > <Text>{item?.label}</Text>
              {item?.require == true ? <Text type="danger">*</Text>:null}
                <Input
                disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                className={`${props?.objectKeys?.includes(item.label2)== true?'warningMessage':''}`}
                  id={item.id}
                  size={item.size}
                  onChange={(e) => {
                    props.updateCompanyDetails(item.name, e.target.value,item.name,item?.label2)
                  }}
                  value={userData?.[item.name]}
                />
                {errorMessage ==  true ? (item?.require == true && props.userdata?.[item.name] == '') || item?.require == true && props.userdata?.[item.name] == undefined  ?  <Text type="danger">{item?.errorMessage}</Text>:null:null}

              </Form.Item>
            }
            else if (item?.type == "Phone") {
              return <Form.Item
                className={item.itemclass}
                rules={[
                  {
                    required: true,
                    message: "Please input your Phone Number",
                  },
                ]}
              >  <Text>{item?.label}</Text>
              {item?.require == true ? <Text type="danger">*</Text>:null}
                <PhoneInput
                disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                  className={`${props?.objectKeys?.includes(item.label2)== true?'warningMessage':''}`}
                  value={userData?.[item.name]}
                  country='pk'
                  id="regPhone"
                  onChange={(Phone) => {
                    props.updateCompanyDetails(item.name, `+${Phone}`,item.name,item?.label2)
                  }
                  }

                />
                {errorMessage ==  true ? (item?.require == true && props.userdata?.[item.name] == '') || item?.require == true && props.userdata?.[item.name] == undefined  ?  <Text type="danger">{item?.errorMessage}</Text>:null:null}
              </Form.Item>
            }
            else if (item?.type == "Select") {
              return <Form.Item
                className={item.itemclass}
                onChange={(e) => {
                }}
                rules={[
                  {
                    required: true,
                    message: "Please input your Country",
                  },
                ]}
              >  <Text>{item?.label}</Text>
              {item?.require == true ? <Text type="danger">*</Text>:null}
                <Select
                  className={`${props?.objectKeys?.includes(item.label2)== true?'warningMessage':''}`}
                  disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                  showSearch
                  value={userData?.[item.name]}
                  id={item.id}
                  size="large"
                  placeholder="Select"
                  onChange={(e) => {
                    // props.selectCountry(e);
                    props.updateCompanyDetails(item.name, e,item.name,item?.label2);
                  }}
                  allowClear
                >
                  {options.map((item, index) => {
                    return <Option value={item}>{item} </Option>;
                  })}
                </Select>
                {errorMessage ==  true ? (item?.require == true && props.userdata?.[item.name] == '') || item?.require == true && props.userdata?.[item.name] == undefined  ?  <Text type="danger">{item?.errorMessage}</Text>:null:null}
              </Form.Item>
            }
            else {
              return <Form.Item className={item?.itemclass}>
                <Button
                  type="primary"
                  className={item.elementclass}
                  size={item.size}
                  loading={props.loading}
                  onClick={() => {
                    NextStep()
                  }}
                >
                  {item.label} <RightOutlined />
                </Button>
              </Form.Item>
            }
          })

        }
      </Form>
    </Card>
  )
}
